import { render, staticRenderFns } from "./AirticketgaiqianRight.vue?vue&type=template&id=0b9ce56c&scoped=true"
import script from "./AirticketgaiqianRight.vue?vue&type=script&lang=js"
export * from "./AirticketgaiqianRight.vue?vue&type=script&lang=js"
import style0 from "./AirticketgaiqianRight.vue?vue&type=style&index=0&id=0b9ce56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ce56c",
  null
  
)

export default component.exports